/**
 * M.2 — NIPE tool: searchVault
 *
 * Read-only. Free-text search over the user's Obsidian vault.
 * F6 added live-row preference (falls back to sample vault).
 */

import type { NipeTool } from './types';

export interface SearchVaultContext {
  searchVault: (
    query: string,
    limit: number,
  ) => Promise<Array<{ path: string; snippet: string; score?: number }>>;
}

export const searchVaultTool: NipeTool<SearchVaultContext> = {
  schema: {
    type: 'function',
    function: {
      name: 'searchVault',
      description:
        "Search the user's Obsidian vault for notes matching a free-text query. Returns up to `limit` matches with a short snippet from each.",
      parameters: {
        type: 'object',
        properties: {
          query: { type: 'string', description: 'Free-text query.' },
          limit: {
            type: 'number',
            description: 'Max results (1-20). Defaults to 8.',
          },
        },
        required: ['query'],
      },
    },
  },
  mutatesRemote: false,
  requiresApproval: false,
  handler: async (args, ctx) => {
    const query = typeof args.query === 'string' ? args.query : '';
    const limit =
      typeof args.limit === 'number'
        ? Math.min(Math.max(1, args.limit), 20)
        : 8;
    if (!query) return { error: 'query required' };
    const matches = await ctx.searchVault(query, limit);
    return { matches };
  },
};
